exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div input[type=text] {\n  width: 150px;\n  height: 40px;\n  margin: 10px 10px 0 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/woReturn.scss
// module id = ../../../../../src/app/components/Purchase/workorder/woReturn.scss
// module chunks = main